import type { TFunction } from "i18next";
import styled from "styled-components";
import { FormSection } from "../../../components/FormSection";
import { RouterButtonLink } from "../../../components/Button";
import { spacing } from "@styling/sizing";
import { withFieldGroup } from "../paymentMethodFormHook";
import { Fields, TextField } from "./paymentMethodFields";

const Actions = styled.div`
  margin-top: ${spacing.x2}px;
`;

type VivaAdminFormData = {
  multiMerchantId: string;
};

const defaultValues: VivaAdminFormData = {
  multiMerchantId: "",
};

export const FieldGroupVivaAdminFields = withFieldGroup({
  defaultValues,
  props: {
    t: undefined as unknown as TFunction,
    storeId: "",
    paymentMethodId: "",
  },
  render: ({ group, t, storeId, paymentMethodId }) => (
    <FormSection title={t("paymentMethodForm.viva.adminOnly")}>
      <Fields>
        <group.AppField name="multiMerchantId">
          {(field) => (
            <TextField
              label={t("paymentMethodForm.viva.multiMerchantId")}
              value={field.state.value}
              onChange={field.handleChange}
              onBlur={field.handleBlur}
            />
          )}
        </group.AppField>
      </Fields>
      {paymentMethodId && (
        <Actions>
          <RouterButtonLink
            to={`/stores/${storeId}/paymentMethods/${paymentMethodId}/viva-transactions`}
            $variant="outlined"
          >
            {t("paymentMethodForm.viva.viewTransactions")}
          </RouterButtonLink>
        </Actions>
      )}
    </FormSection>
  ),
});
